export default "__VITE_ASSET__fddd818e__"